import { Suspense, ComponentType } from 'react';

// project imports
import Loader from './Loader';
import SynletsLoader from './SynletsLoader';

interface LoadableOptions {
  /** Show branded SynletsLoader in Suspense fallback (for pages without their own loader) */
  branded?: boolean;
  /** SynletsLoader variant when branded — 'fullscreen' for auth, 'page' for main app */
  loaderVariant?: 'page' | 'fullscreen';
}

export default function Loadable<P extends object>(
  Component: ComponentType<P>,
  { branded = false, loaderVariant = 'page' }: LoadableOptions = {}
) {
  const WrappedComponent = (props: P) => (
    <Suspense
      fallback={
        branded ? (
          <>
            <Loader />
            <SynletsLoader variant={loaderVariant} message="Loading..." />
          </>
        ) : (
          <Loader />
        )
      }
    >
      <Component {...props} />
    </Suspense>
  );

  return WrappedComponent;
}
